import React from "react";

import Range from "rc-slider/lib/Range";
import "./externalStyles.scss";

const RangeSlider = ({
  min,
  max,
  value,
  onChange,
  onBeforeChange,
  onAfterChange,
  trackStyle,
  handleStyle,
  className,
  marks,
  step,
  ariaLabelGroupForHandles,
  disabled,
}) => (
  <Range
    trackStyle={trackStyle}
    handleStyle={handleStyle}
    onBeforeChange={onBeforeChange}
    onAfterChange={onAfterChange}
    min={min}
    max={max}
    value={value}
    onChange={onChange}
    className={className}
    marks={marks}
    step={step}
    disabled={disabled}
    ariaLabelGroupForHandles={ariaLabelGroupForHandles}
  />
);

export default RangeSlider;
